import { DocsLoader } from './DocsLoader';

export const ServiceSelector_docs = {
    
    select: (service: string) => {

        let myService
        console.log(service)
        switch(service){
            case "about":
            case "contacts":
            case "services":
            case "marketconnect":
            case "itp":
            case "mifid":
            case "compliance wks":
            case "dati storici":
            case "book consolidato":
            case "best execution engine":
            case "otc market place":
            case "Market Connect Feed":
            case "Ftp":
            case "Api":
            case "Web Services":
            case "Finsite":
            case "Basic":
            case "Premium":
            case "Full":
            case "Investor Relations":
                myService = DocsLoader.none;
                break;
            case "Market Connect Web":
                myService = DocsLoader.web;
                break;
            case "Market Connect Client":
                myService = DocsLoader.client;
                break;
        }  

        return myService; 
    }
};